<template>
  <my-view :UserRegister="UserRegister" :GetVerCode="GetVerCode" :CheckMobileIsRegisted="CheckMobileIsRegisted"></my-view>
</template>

<script>
import {
  UserRegister,
  GetVerCode,
  CheckMobileIsRegisted,
} from "@/pages/page1/api/modules/login";

import MyView from "@/pages/publicView/login/register_view.vue";

export default {
  components: { MyView },
  data() {
    return {
      UserRegister,
      GetVerCode,
      CheckMobileIsRegisted,
    };
  },
};
</script>